import { z } from 'zod'
export const systemConfigurationSchema = z.object({
    primaryColor: z.string().min(1, 'El color primario es requerido'),
    secondaryColor: z.string().min(1, 'El color  secundario es requerido'),
    status: z.boolean(),
    nameTheme: z.string().min(1, 'El nombre del tema es requerido'),

})
export const smtpConfigurationSchema = z.object({
    sender: z.string().min(1, 'El nombre del remitente es obligatorio'),
    senderEmail: z.string().min(1, "El correo es obligatorio").email("Formato incorrecto"),

    //obligatorios
    serverSmtp: z.string().min(1, 'El servidor es obligatorio'),
    port: z
        .number()
        .min(1, 'El puerto es obligatorio')
        .max(65535, 'El puerto máximo es 65535')
        ,
    typeSecurity: z.string().min(1, 'El tipo de seguridad es obligatorio'),
    userSmtp: z.string().min(1, 'El usuario es obligatorio').email("Formato incorrecto"),
    password: z.string().optional(),
    isActive: z.boolean().optional().default(true)

    // ssl:z.boolean().optional(),
    // tls:z.boolean().optional(),
})